export interface ArticleCluster {
  id: string;
  title: string;
  slug: string;
  description: string;
  imageSeq: string;
  bgClass: string;
  articles: {
    title: string;
    slug: string;
  }[];
}

export const articleClusters: ArticleCluster[] = [
  {
    id: 'beginner',
    title: 'Guida per Principianti',
    slug: 'guida-principianti',
    description: 'Tutto quello che devi sapere per iniziare con Itaobuy Spreadsheet',
    imageSeq: 'article-beginner',
    bgClass: 'bg-[#f5f0eb]',
    articles: [
      { title: 'Cos\'è Itaobuy Spreadsheet', slug: 'cos-e-itaobuy-spreadsheet' },
      { title: 'Come Funziona Itaobuy', slug: 'come-funziona-itaobuy' },
      { title: 'Iniziare con Itaobuy', slug: 'iniziare-itaobuy' },
    ],
  },
  {
    id: 'safety',
    title: 'Sicurezza & Affidabilità',
    slug: 'sicurezza',
    description: 'Guide complete per acquistare in sicurezza dai marketplace cinesi',
    imageSeq: 'article-safety',
    bgClass: 'bg-[#ebf5ed]',
    articles: [
      { title: 'Guida alla Sicurezza', slug: 'sicurezza-acquisti' },
      { title: 'QC Photos: Cosa Sono', slug: 'qc-photo-guida' },
      { title: 'Metodi di Pagamento Sicuri', slug: 'pagamenti-sicuri' },
    ],
  },
  {
    id: 'comparison',
    title: 'Confronti & Analisi',
    slug: 'confronti',
    description: 'Tabelle comparative e analisi approfondite per scelte informate',
    imageSeq: 'article-comparison',
    bgClass: 'bg-[#f5f0f0]',
    articles: [
      { title: 'Confronto Shopping Agent', slug: 'confronto-agent' },
      { title: 'Analisi dei Prezzi', slug: 'analisi-prezzi' },
      { title: 'Alternative a Itaobuy', slug: 'alternative-itaobuy' },
    ],
  },
  {
    id: 'advanced',
    title: 'Utenti Avanzati',
    slug: 'avanzati',
    description: 'Strategie e ottimizzazioni per utenti esperti di Itaobuy',
    imageSeq: 'article-advanced',
    bgClass: 'bg-[#f0f2f5]',
    articles: [
      { title: 'Strategie di Acquisto', slug: 'strategie-itaobuy' },
      { title: 'Risparmio Massimo', slug: 'risparmio-itaobuy' },
      { title: 'Ottimizzazione Ordini', slug: 'ottimizzazione-ordini' },
    ],
  },
];